import { createBrowserRouter } from "react-router-dom";
import Home from "../pages/Home/home";
import AboutUs from "../pages/About/about";
import {Services,Equipment} from "../pages/Service/service";
import MainService from "../pages/MainServices/mainService";
import { Clients } from "../pages/Clients/clients";
import Blog from "../pages/blog/blog";
import BlogPage from "../pages/blog/page";
import Catalog from "../pages/MainServices/catalog";
import ContactUs from "../pages/Contact/contact";
import {Gallery,ViewGallery,VideosList} from "../pages/Gallery/gallery";
import Strengths from "../pages/Strengths/strength";
import Announcements from "../pages/Announcments/announcements";
import CSR from "../pages/CSR/csr";
import Workshop from "../pages/worshop/workshop";
const router = createBrowserRouter([
    {
        path: "/",
        element: <Home />
    },
    {
        path: "/aboutus",
        element: <AboutUs />
    },
    {
        path: "/services",
        element: <Services />
    },
    {
        path: "/mainService",
        element: <MainService />,
    },
    {
        path: "/clients",
        element: <Clients />
    },
    {
        path: "/ourprojects",
        element: <Blog />
    },
    {
        path: "/blogpage",
        element: <BlogPage />
    },
    {
        path: "/catalog",
        element: <Catalog />
    },
    {
        path: "/contactus",
        element: <ContactUs />
    },
    {
        path: "/gallery",
        element: <Gallery />,
    },
    {
        path:"/viewgallery",
        element: <ViewGallery />,
    },
    {
        path:"/equipments",
        element: <Equipment />,
    },
    {
        path:"/videos",
        element: <VideosList />,
    },
    {
        path:"/strength",
        element: <Strengths />,
    },
    {
        path:"/announcements",
        element: <Announcements />,
    },
    {
        path:"/csr",
        element: <CSR />,
    },
    {
        path:"/workshop",
        element: <Workshop />,
    }
]);

export default router;